var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.03906 0C3.62106 0 0.0390625 3.582 0.0390625 8C0.0390625 12.418 3.62106 16 8.03906 16C12.4571 16 16.0391 12.418 16.0391 8C16.0391 3.582 12.4571 0 8.03906 0ZM11.7451 5.787L7.91306 11.644C7.91206 11.645 7.91006 11.646 7.91006 11.647C7.89006 11.677 7.87906 11.711 7.85406 11.739C7.81906 11.777 7.77406 11.797 7.73406 11.826C7.72406 11.833 7.71406 11.841 7.70306 11.848C7.64106 11.887 7.57706 11.913 7.50706 11.93C7.48406 11.936 7.46306 11.942 7.43906 11.946C7.38336 11.9537 7.32693 11.9543 7.27106 11.948C7.2316 11.9455 7.19245 11.9395 7.15406 11.93C7.11446 11.9181 7.07598 11.9027 7.03906 11.884C7.00706 11.869 6.97306 11.865 6.94306 11.846C6.92106 11.832 6.90906 11.81 6.89006 11.793C6.88206 11.786 6.87206 11.784 6.86406 11.777L4.63306 9.714C4.50082 9.58702 4.42367 9.41323 4.4182 9.22998C4.41273 9.04672 4.47937 8.86864 4.60379 8.73399C4.72822 8.59935 4.90051 8.51889 5.08362 8.50992C5.26674 8.50095 5.44606 8.56417 5.58306 8.686L7.19806 10.18L10.5731 5.021C10.6746 4.86558 10.8338 4.75688 11.0155 4.71881C11.1972 4.68074 11.3866 4.71642 11.5421 4.818C11.6975 4.91958 11.8062 5.07873 11.8442 5.26046C11.8823 5.44218 11.8466 5.63158 11.7451 5.787Z",
    fill: "#75F08A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusDone);
export default __webpack_public_path__ + "static/media/status_done.90eb8737af5f8cc8e409048ed722e142.svg";
export { ForwardRef as ReactComponent };